import './bootstrap.ts';

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { setupCalendar } from 'v-calendar'
import Components from './components/index.js'

import * as Sentry from "@sentry/vue"

const pinia = createPinia()
const app = createApp(
  {
    components: Components,
  }
)

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_VUE_DSN,
  sendDefaultPii: true
})

app.use(pinia)
app.use(setupCalendar, {})
app.mount('#app')
